import {
    CircularProgress,
    Dialog,
    DialogContent,
    type DialogProps,
    DialogTitle,
    Typography,
    styled
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledDialog = styled(Dialog)`
    & .MuiDialog-paper {
        width: 500px;
    }

    & .MuiDialogTitle-root {
        background-color: ${(props) => props.theme.palette.primary.main};
        color: white;
    }

    & .MuiDialogTitle-root + .MuiDialogContent-root {
        padding-top: 16px;
    }

    & .MuiDialogContent-root {
        display: flex;
        align-items: center;
        justify-content: center;
    }
` as typeof Dialog;

export type SendingCalendarInviteModalProps = DialogProps & {};

const RosterSendingCalendarInviteModal = (props: SendingCalendarInviteModalProps) => {
    const { onClose, ...other } = props;

    const { t } = useTranslation('roster');

    const handleClose = () => {
        onClose?.({}, 'backdropClick');
    };

    return (
        <StyledDialog onClose={handleClose} {...other}>
            <DialogTitle>{t('sending-calendar-invitations')}</DialogTitle>

            <DialogContent>
                <Typography mr={2}>{t('sending')}</Typography>
                <CircularProgress disableShrink />
            </DialogContent>
        </StyledDialog>
    );
};

export default RosterSendingCalendarInviteModal;
